'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsUsers = require('./analytics-users.html');

var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);

var _analyticsUsers3 = require('./analytics-users.controller');

var _analyticsUsers4 = _interopRequireDefault(_analyticsUsers3);

require('./analytics-users.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsUsers2.default,
  controller: _analyticsUsers4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-users/analytics-users.component.js
 **/